interface RBLColorIndicatorProps {
  color: string;
  label: React.ReactNode;
}

export const RBLColorIndicator = ({ color, label }: RBLColorIndicatorProps) => {
  const getColorClass = (bgColor: string) => {
    switch (bgColor) {
      case 'green':
        return 'vai-bg-green-500';
      case 'yellow':
        return 'vai-bg-yellow-400';
      case 'orange':
        return 'vai-bg-orange-500';
      case 'red':
        return 'vai-bg-red-500';
      default:
        return 'vai-bg-gray-500';
    }
  };

  return (
    <div className="vai-w-1/5 vai-flex vai-flex-col vai-items-center">
      <div
        className={`vai-w-8 vai-h-8 vai-rounded-lg vai-mb-2 ${getColorClass(
          color,
        )}`}
      />
      <p className="color-label vai-text-sm">{label}</p>
    </div>
  );
};
